// extracted by mini-css-extract-plugin
module.exports = {"tags":"D_ck","tags__item":"D_cl"};